// Components==============
import Button from 'components/UI/Button/Button';
import Modal from 'components/UI/Modal/Modal';
import UploadProfileImage from 'components/UI/UploadProfileImage/UploadProfileImage';
import { useRedux } from 'hooks/useRedux';
import { useTranslate } from 'hooks/useTranslate';
import React from 'react';
import './UploadImageModal.module.scss';
import { usePermission } from 'hooks/usePermission';
import { useReduxAction } from 'hooks/useReduxAction';
import updateUser from 'actions/user/update';
import Input from 'components/UI/Form/Input';
import FormContext from 'utilities/FormContext';
import { useFormValues } from 'hooks/useFormValues';
// =========================

export default function UploadImageModal({
  setModalIsOpen,
}: {
  setModalIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const translate = useTranslate();

  const dispatch = useReduxAction();

  const user = useRedux((state) => state.authentication?.user);

  const { formValues, handleChange, errors, setErrors } = useFormValues({
    id: user?.id,
    phonenumber: '',
    website: '',
    company: '',
  });

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    dispatch(updateUser(formValues))
      .catch(({ response }: { response: any }) => {
        setErrors((prev: any) => ({ ...prev, ...response?.data?.errors }));
      })
      .then(() => {
        setModalIsOpen(false);
      });
  }

  const hasAvatar = user?.avatar_url && user?.avatar_url?.length > 1;

  const isExtern = usePermission(['Extern']);

  const valuesNotFilledIn = !formValues.phonenumber || !user?.avatar_url;

  return (
    <Modal
      size="medium"
      setModalIsOpen={setModalIsOpen}
      noCross={isExtern}
      preventClose={!!(isExtern && !hasAvatar)}
    >
      <div styleName="wrapper">
        <UploadProfileImage />
        {isExtern ? (
          <>
            <h2>Voer je gegevens in</h2>
            <p>
              Om als externe projecten te kunnen bekijken en beoordelen hebben
              we gegevens van je nodig om to valideren wie we voor ons hebben.
            </p>
            <form onSubmit={handleSubmit}>
              <FormContext
                formValues={formValues}
                errors={errors}
                onChange={handleChange}
              >
                <Input
                  label="Telefoonnummer*"
                  name="phonenumber"
                  placeholder="06 12 34 56 78"
                  required
                  labelLocation="left"
                />
                <Input
                  label="Bedrijf"
                  name="company"
                  placeholder="Bedrijf"
                  required={false}
                  labelLocation="left"
                />
                <Input
                  label="Website"
                  name="website"
                  placeholder="Website"
                  required={false}
                  labelLocation="left"
                />
              </FormContext>
              <div styleName="button-wrapper">
                <Button inactive={valuesNotFilledIn}>
                  {valuesNotFilledIn
                    ? 'Voeg eerst een foto en telefoonnummer toe'
                    : 'Opslaan'}
                </Button>
              </div>
            </form>
          </>
        ) : (
          <>
            <h2>
              {translate(
                hasAvatar
                  ? 'project.groupswork-popups.owner-image-popup.title2'
                  : 'project.groupswork-popups.image-popup.title'
              )}
            </h2>
            <p>
              {translate(
                hasAvatar
                  ? 'project.groupswork-popups.owner-image-popup.description2'
                  : 'project.groupswork-popups.image-popup.description1'
              )}
            </p>
            <div styleName="button-wrapper">
              {!hasAvatar ? (
                <Button color="grey" onClick={() => setModalIsOpen(false)}>
                  {translate(
                    'project.groupswork-popups.image-popup.upload-later'
                  )}
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    setModalIsOpen(false);
                  }}
                >
                  {translate('general.terms.done')}
                </Button>
              )}
            </div>
          </>
        )}
      </div>
    </Modal>
  );
}
